import { useAuth0 } from "@auth0/auth0-react";
import MyTable from "components/Table";
import FinanceService from "Lib/API/Finance";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";
import Spinner from "components/spinner";
import "../index.scss";
import { DateFormetContext } from "../../../../app/App.js";
import { toastr } from "react-redux-toastr";

const TitlesBody = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div`
  color: #b5b5c3;
  font-size: 12px;
  margin-inline-end: 23px;
`;

const Circle = styled.div`
  height: 7px;
  width: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-inline-end: 3px;
`;

export const InvoiceDetails = ({ invoiceId }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = React.useState(false);
  const [pageSize, _] = useState(3);
  const [list, setList] = React.useState([]);
  const [invoiceDetails, setInvoiceDetails] = React.useState({});

  const enableLoading = (value) => {
    setLoading(value);
  };
  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getInvoicesById(token, invoiceId)

        .then((res) => {
          if (res) {
            res.product_details.map((item, index) => {
              item.id = index;
              return item;
            });
            setInvoiceDetails(res);
            setList(res?.product_details);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, [getAccessTokenSilently]);

  const columns = [
    {
      field: "product_id",
      resizable: true,
      headerName: "#",
      sortable: false,
      width: 30,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.id}</div>;
      },
    },
    {
      field: "prod_name",
      resizable: true,
      headerName: "PRODUCT",
      sortable: false,
      flex: 1,
      renderCell: (data) => {
        return (
          <div
            style={{ fontSize: "14px" }}
            className="d-flex justify-content-start"
          >
            {data?.row?.prod_name}
          </div>
        );
      },
    },
    {
      field: "prod_desc",
      resizable: true,
      headerName: "DESCRIPTION",
      flex: 1,
      sortable: false,
      renderCell: (data) => {
        return (
          <div
            style={{
              fontSize: "14px",
              color: data?.row?.prod_price < 0 ? "#F1585E" : "#7edc90",
            }}
          >
            {data?.row?.prod_desc}
          </div>
        );
      },
    },
    {
      field: "qty",
      resizable: true,
      headerName: "QTY",
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.qty}</div>;
      },
    },
    {
      field: "prod_price",
      resizable: true,
      headerName: "AMOUNT",
      sortable: false,
      renderCell: (data) => {
        return (
          <div
            style={{
              fontSize: "14px",
              color: data?.row?.prod_price < 0 ? "#F1585E" : "#7edc90",
            }}
          >
            {data?.row?.prod_price}
          </div>
        );
      },
    },
  ];
  const paymentStatus = invoiceDetails?.payment_amount?.payment_status;

  if (loading) return <Spinner />;
  return (
    <dv className="add-ledger" style={{ width: "100%" }}>
      <div className="form-title" style={{ color: "#464E5F", fontSize: 18 }}>
        Invoice Details
      </div>
      <div
        className="form-title"
        style={{ color: "#2455EF", fontSize: 16, marginBottom: 30 }}
      >
        {invoiceDetails?.inv_id}
      </div>
      <TitlesBody>
        <div>
          <Title>
            <div>ISSUES DATE</div>
          </Title>

          <Title style={{ marginTop: 7 }}>
            <span> DUE DATE </span>
          </Title>
        </div>
        <div>
          <div style={{ marginInlineEnd: 50, color: "#575757" }}>
            {moment(invoiceDetails?.inv_issue_date)
              .utcOffset("+0100")
              .format(dateFormet)}
          </div>
          <div style={{ marginInlineEnd: 50, color: "#575757", marginTop: 7 }}>
            {moment(invoiceDetails?.inv_due_date)
              .utcOffset("+0100")
              .format(dateFormet)}
          </div>
        </div>
        <div style={{ marginInlineStart: 25 }}>
          <Title> DATE BALANCE </Title>

          <Title style={{ marginTop: 7 }}>MEMBER NAME</Title>
        </div>
        <div>
          <div style={{ marginInlineEnd: 50, color: "#F1585E" }}>
            {moment(invoiceDetails?.inv_due_date).diff(
              moment(invoiceDetails?.inv_issue_date),
              "days"
            )}
            {` days left`}
          </div>
          <div style={{ marginInlineEnd: 50, color: "#575757", marginTop: 7 }}>
            {invoiceDetails?.memberDetails?.member_name}
            <br />
            <span style={{ color: "#2455EF", fontSize: "11px" }}>
              #{invoiceDetails?.memberDetails?.member_serial}
            </span>
          </div>
        </div>
        <div style={{ marginInlineStart: 25 }}>
          <Title>TOTAL</Title>

          <Title style={{ marginTop: 7 }}>STATUS</Title>
        </div>
        <div>
          <div
            style={{
              marginInlineEnd: 50,
              fontSize: "14px",
              color: paymentStatus === "Paid" ? "#7edc90" : "#F1585E",
            }}
          >
            ${invoiceDetails?.payment_amount?.total}
          </div>
          <div
            style={{
              marginInlineEnd: 50,
              color: paymentStatus === "Paid" ? "#7edc90" : "#F1585E",
              fontSize: "12px",
              marginTop: 3,
            }}
          >
            <Circle
              style={{
                backgroundColor:
                  paymentStatus === "Paid" ? "#7edc90" : "#F1585E",
              }}
            />
            {paymentStatus === "Paid" ? "Paid" : "Open"}
          </div>
        </div>
      </TitlesBody>
      <div className="add-ledger-form pb-10" style={{ display: "flex" }}>
        <Card
          className="card card-custom py-5 pl-5 pr-5 "
          style={{
            border: "1px solid #70707034",
            background: "#F9FAFC 0% 0% no-repeat padding-box",
            marginInlineEnd: 15,
            width: "67%",
            borderRadius: 0,
          }}
        >
          <MyTable
            className="family-table"
            rows={list}
            columns={columns}
            pageSize={pageSize}
            loading={loading}
            rowHeight={50}
            onSelectionModelChange={(newSelectionModel) => {}}
            hideFooter
          />
        </Card>
        <Card
          className="card card-custom py-5 pl-10 pr-10 "
          style={{
            border: "1px solid #70707034",
            background: "#F9FAFC 0% 0% no-repeat padding-box",
            width: "30%",
            borderRadius: 0,
          }}
        >
          <div style={{ color: "#464E5F", fontSize: 18, fontWeight: 600 }}>
            Summary
          </div>
          <div
            style={{
              marginTop: 40,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div style={{ marginTop: 8, color: "#9B9B9B", fontSize: 15 }}>
                Amount
              </div>
              <div style={{ marginTop: 8, color: "#9B9B9B", fontSize: 15 }}>
                Tax
              </div>
              <div style={{ marginTop: 8, color: "#9B9B9B", fontSize: 15 }}>
                Discount (
                {invoiceDetails?.payment_amount?.discount?.dis_type +
                  invoiceDetails?.payment_amount?.discount?.dis_value}
                )
              </div>
            </div>
            <div>
              <div style={{ marginTop: 8, color: "#4CAF50", fontSize: 15 }}>
                ${invoiceDetails?.payment_amount?.sub_total}
              </div>
              <div style={{ marginTop: 8, color: "#9B9B9B", fontSize: 15 }}>
                $
                {invoiceDetails?.product_details
                  ?.map(
                    (prod) => (prod.prod_price * prod.prod_tax * prod.qty) / 100
                  )
                  .reduce((a, b) => a + b, 0)}
              </div>
              <div style={{ marginTop: 8, color: "#9B9B9B", fontSize: 15 }}>
                {invoiceDetails?.payment_amount?.discount?.dis_type === "%"
                  ? (Number(
                      invoiceDetails?.payment_amount?.discount?.dis_value
                    ) *
                      Number(invoiceDetails?.payment_amount?.sub_total)) /
                    100
                  : invoiceDetails?.payment_amount?.discount?.dis_type === "$"
                  ? Number(invoiceDetails?.payment_amount?.sub_total) -
                    Number(invoiceDetails?.payment_amount?.discount?.dis_value)
                  : 0}
              </div>
            </div>
          </div>
          <hr></hr>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ color: "#000000", fontSize: 18 }}>Total</div>

            <div> ${invoiceDetails?.payment_amount?.total}</div>
          </div>
        </Card>
      </div>
    </dv>
  );
};
